import NetInfo from '@react-native-community/netinfo';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import { BehaviorSubject } from 'rxjs';
import config from '../../config';

export const useNetworkStatusListener = () => {
  useEffect(() => {
    NetInfo.configure({
      useNativeReachability: Platform.OS === 'ios' ? true : false,
      reachabilityUrl: config.HEALTH_CHECK_URL,
      reachabilityTest: async response => response.status === 200,
      reachabilityLongTimeout: 10 * 1000,
      reachabilityShortTimeout: 5 * 1000,
      reachabilityRequestTimeout: 5 * 1000,
      reachabilityMethod: 'GET',
    });

    const unsubscribe = NetInfo.addEventListener(state => {
      const { isConnected, isInternetReachable } = state;
      if (isConnected) {
        if (isInternetReachable) {
          networkStatusSubject.next(true);
        } else if (isInternetReachable === false) {
          networkStatusSubject.next(false);
        }
      } else {
        networkStatusSubject.next(false);
      }
    });
    return unsubscribe;
  }, []);
};
export const networkStatusSubject = new BehaviorSubject<boolean | null>(null);
